import axios from 'axios'
import {Message} from 'element-ui'
import store from '../store'
import router from '../router'

axios.defaults.withCredentials = true
// 创建axios实例
const service = axios.create({
  // baseURL: process.env.BASE_API, // api 的 base_url
  timeout: 150000 // 请求超时时间
})

const encodeOption = option => {
  let str = ''
  for (const key in option) {
    str += `&${key}=${option[key]}`
  }
  return str.replace('&', '')
}

// request拦截器
service.interceptors.request.use(
  config => {
    if ((config.method === 'post' || config.method === 'put') && !config.isEncodeOption) {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8'
      delete config.isEncodeOption
      config.data = encodeOption(config.data)
    }
    if (config.isEncodeOption) {
      config.headers['Content-Type'] = 'application/json'
      delete config.isEncodeOption
    }
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    /**
     * status不等于1是抛错 可结合自己业务进行修改，
     * 目前只有 1 和 0 两个返回值
     */
    let res = response.data
    if (typeof res === 'string') {
      res = JSON.parse(res)
    }
    if (Number.parseInt(res.status) !== 1) {
      Message({
        message: res.message,
        type: 'error',
        duration: 3 * 1000
      })
      return Promise.reject(res.message)
    } else {
      return res
    }
  },
  error => {
    let res = error.response.data
    if (typeof res === 'string') {
      try {
        res = JSON.parse(error.response.data)
      } catch (e) {
        res = error.response.data
      }
    }
    // 403后重新获取用户信息 如果失败后返回登入页面  并且正则表达式跳过获取用户信息的请求走下面逻辑防止死循环
    if (Number(error.response.status) === 403 && /^\/api\/admin\/user\/(\d+)\/$/.test(error.config.url) === false) {
      store.dispatch('GetInfo').then(() => { // 拉取用户信息
        Message.error({
          message: res.message,
          type: 'error',
          duration: 3 * 1000
        })
      }).catch((err) => {
        store.dispatch('FedLogOut').then(() => {
          router.push('/login').then(r => {
            Message.error({
              message: '请重新登入',
              type: 'error',
              duration: 3 * 1000
            })
          })
        })
      })
    } else {
      if (typeof res === "string") {
        Message({
          message: res,
          type: 'error',
          duration: 3 * 1000
        })
      } else {
        Message({
          message: res.message,
          type: 'error',
          duration: 3 * 1000
        })
      }

    }
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js